import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { IBoardTreePageDto } from "../models/dto";
import { RootStore } from "./rootStore";

export default class BoardStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  loadingNodes: boolean = false;
  mainBoardTree: IBoardTreePageDto | null = null;

  loadMainBoard = async (languageId?: number) => {
    try {
      this.loadingNodes = true;
      const dto = await agent.Board.main(languageId);
      runInAction(() => {
        this.mainBoardTree = dto;
        if (dto.languageId)
          this.rootStore.commonStore.setSelectedLanguageId(dto.languageId);
        this.loadingNodes = false;
      });
      return dto;
    } catch (error) {
      this.loadingNodes = false;
      console.log(error);
    }
  };

  loadBoardContent = async (nodeId: number, languageId?: number) => {
    const { commonStore } = this.rootStore;
    try {
      const dto = await agent.Board.content(nodeId, languageId);
      runInAction(() => {
        commonStore.setBoardBrowsePageContent(dto);
      });
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
}
